import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {OrderUpsellBundleCtaComponent} from './order-upsell-bundle-cta.component';
import {RouterModule} from '@angular/router';
import {OrderUpsellService} from '@app/product/services/order-upsell.service';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderUpsellBundleCtaComponent: {
          component: OrderUpsellBundleCtaComponent,
        },
      },
    }),
    OrderUpsellBundleCtaComponent,
  ],
  providers: [OrderUpsellService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [OrderUpsellBundleCtaComponent],
})
export class OrderUpsellBundleCtaModule {}
